import cryptHelper from '@/libs/helper/cryptHelper'

const storageHelper = {
  getLocalStorageItem(key) {
    const data = localStorage.getItem(key)

    if (data) {
      return cryptHelper.sysDecrypt(data)
    }

    return false
  },
  setLocalStorageItem(key, data) {
    return localStorage.setItem(key, cryptHelper.sysEncrypt(data))
  },
  deleteLocalStorageItem(key) {
    localStorage.removeItem(key)
  },
}

export default storageHelper
